"use strict";
var ACC;
ACC.slimbanner = {
    _autoload: [
        "bindSlimBanner"
    ],

    bindSlimBanner: function() {
        $(".slim-banner-with-cta>a").on("click", function() {
            ACC.slimbanner.gtmSlimBannerCtaClicked($(this));
        })
    },

    gtmSlimBannerCtaClicked: function($component) {
		if ($component != null) {
			var componentId = $component.data("componentid");
			var viewNumber = $component.data("viewnumber");
			if (componentId.length != null && viewNumber != null) {
				ACC.gtm.trackPromotionClickGtmEvent(componentId, viewNumber);
	        }
	    }
    },

    // Helper to dynamically change the alt text of the slim banner with cta img
    resizeSlimBannerAltText: function(desktopAlt, tabletAlt, mobileAlt, id) {
        const altText = ACC.common.chooseResizeVal(desktopAlt, tabletAlt, mobileAlt);
        const imgId = 'slim-banner-cta-image-' + id;
        document.getElementById(imgId).alt = altText;
    }
};
